
<nz-skeleton *ngIf="isFetchingAuthDetails" [nzParagraph]="{rows: 15}"></nz-skeleton>

<nz-card class="" *ngIf="authDetails != null && authDetails.connectionStatus">
<div class="">
    <div class="d-flex justify-content-space-between">
    <div class="fs-30">
        Connection Status
    </div>
    <div class="right">
        <button nz-button nzType="primary" (click)="testConnection('test')" [nzLoading]="isTestingConnection">Test Connection</button>
        <br><a (click)="openTroubleShootDoc()"><u>Troubleshoot</u></a>
    </div>
</div>
    <hr/>
<div nz-row class="fs-18">
    <div nz-col nzSpan="12">
        <div class="d-flex m-1">
            <div class="w-50 fw-bold">
                Connection Status
            </div>
            <div>
                <span nz-icon nzType="check-circle" nzTheme="outline"></span>
                {{authDetails.connectionStatus ? 'Connected' : 'Disconnected'}}
            </div>
        </div>
        <div class="d-flex m-1">
            <div class="w-50 fw-bold">
                Company Name
            </div>
            <div>
                {{authDetails.companyName}}
            </div>
        </div>
        <div class="d-flex m-1">
            <div class="w-50 fw-bold">
                Access Token
            </div>
            <div class="tooltip">
                {{authDetails.accessToken.slice(0,15)}}...
                <span class="tooltiptext">{{authDetails.accessToken}}</span>
            </div>
        </div>
        <div class="d-flex m-1">
            <div class="w-50 fw-bold">
                Refresh Token
            </div>
            <div class="tooltip">
                {{authDetails.refreshToken.slice(0,15)}}...
                <span class="tooltiptext refresh">{{authDetails.refreshToken}}</span>
            </div>
        </div>
        <div class="d-flex m-1">
            <div class="w-50 fw-bold">
                Last Sync Date Time
            </div>
            <div>
                {{getLocalDateTime(authDetails.customerLastSyncDateTime) | date: 'MM/dd/yyyy hh:mm:ss a'}} (Customer)<br>
                {{getLocalDateTime(authDetails.invoiceLastSycDateTime) | date: 'MM/dd/yyyy hh:mm:ss a'}} (Invoice)
            </div>
        </div>
        <div class="center">
            <button nz-button (click)="disconnectFromQBO()" [nzLoading]="isDisconnecting" class="modal-footer-btn cancel-btn w-auto mt-2">Disconnect</button>
        </div>
    </div>
    <div nz-col nzSpan="12">
        <div class="p-3"></div>
        <div class="d-flex m-1">
            <div class="w-50 fw-bold">
                Expiry Date Time
            </div>
            <div>
                {{authDetails.accessTokenExpiresIn ? (getLocalDateTime(authDetails.accessTokenExpiresIn) | date: 'MM/dd/yyyy hh:mm:ss a') : '-'}}
            </div>
        </div>
        <div class="d-flex m-1">
            <div class="w-50 fw-bold">
                Expiry Date Time
            </div>
            <div>
                {{authDetails.refreshTokenExpiresIn ? (getLocalDateTime(authDetails.refreshTokenExpiresIn) | date: 'MM/dd/yyyy hh:mm:ss a') : '-'}}
            </div>
        </div>
    </div>
</div>
</div>
</nz-card>
<div *ngIf="authDetails==null && !isFetchingAuthDetails" class="connectBtnContainer">
    <a [href]="'https://appcenter.intuit.com/connect/oauth2?client_id='+appClientId+'&response_type=code&scope=com.intuit.quickbooks.accounting%20profile%20email%20com.intuit.quickbooks.payment%20openid&redirect_uri='+redirectUrl+'&state=b73c7962bb17739892df6853ecc95f0fe71ea1873c8e3fa7bdd2bd2faffa152f'"><img src="../assets/images/connectBTN.png"/></a>
</div>
<div nz-row class="pt-2">
    <div nz-col nzSpan="24">
        <nz-table [nzData]="services" #servicesTable [nzShowPagination]="false" [nzOuterBordered]="false">
            <thead>
                <tr>
                  <th>Service</th>
                  <th>Check Connection</th>
                  <th>Status</th>
                  <!-- <th *ngIf="services[0].status == 'Stopped'"></th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of servicesTable.data;let i=index">
                  <td>{{data.title}}</td>
                  <td>
                    <button nz-button nzType="primary" (click)="checkServiceStatus(data.id)" [nzLoading]="data.isLoading">Test Connection</button></td>
                  <td [ngClass]="data.status == 'Running' ? 'cl-green' : 'cl-red btnRestart'">
                    {{data.status}}
                    <button *ngIf="i==0 && data.status == 'Stopped'" nz-button nzType="primary" (click)="restartService(data.id)" [nzLoading]="isRestartingService">Restart</button>
                  </td>
                  <!-- <td>
                    
                  </td> -->
                </tr>
              </tbody>
        </nz-table>
        <!-- <div class="d-flex m-1" *ngFor="let service of services">
            <div class="w-50">
                {{service.title}}
            </div>
            <div>
                <button nz-button nzType="primary" (click)="checkServiceStatus(service.id)" [nzLoading]="service.isLoading">Test Connection</button>
            </div>
            <div>
                {{service.status}}
            </div>
        </div> -->
    </div>
</div>